import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(() => ({
  panel: {
    marginBottom: 8,
    borderRadius: 8,
  },
  summary: {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    minHeight: 48,
  },
  summaryContent: {
    margin: '8px 0',
  },
  title: {
    fontWeight: 500,
    color: '#333',
    fontSize: 14,
  },
  details: {
    padding: '16px',
    display: 'block',
  },
  required: {
    color: '#d32f2f',
    marginLeft: 4,
    fontSize: 12,
  },
}));

function ExpandableSection({
  title,
  children,
  defaultExpanded,
  required,
  expanded,
  onChange,
  panelId,
}) {
  const classes = useStyles();

  const isControlled = expanded !== undefined && onChange !== undefined;

  return (
    <ExpansionPanel
      className={classes.panel}
      defaultExpanded={!isControlled ? defaultExpanded : undefined}
      expanded={isControlled ? expanded : undefined}
      onChange={isControlled ? onChange(panelId) : undefined}
      elevation={1}
    >
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.summary}
        classes={{ content: classes.summaryContent }}
      >
        <Typography className={classes.title}>
          {title}
          {required && <span className={classes.required}>*</span>}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

ExpandableSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  required: PropTypes.bool,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  panelId: PropTypes.string,
};

ExpandableSection.defaultProps = {
  defaultExpanded: false,
  required: false,
  expanded: undefined,
  onChange: undefined,
  panelId: '',
};

export default ExpandableSection;
